import reducers from './reducers';

export default {

  'SET_QUOTATION':   reducers.quotationsReducer,
}